import { useState, useEffect } from "react";
import gsap from "gsap";
import Container from "../components/Container";
import OipUi from "./OipUi";
import Lottie from "lottie-web";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function OipContainer() {
  const [count, setCount] = useState(0);

  const descriptions = [
    {
      value: (
        <h1>
          <span className=" text-[#FF3452] text-3xl">
            ESTABLISH YOUR DESTINATION’S
          </span>{" "}
          <br />
          VARIOUS ACCESS AND TAKE BACK CONTROL ON IT’S VALUE UPFRONT, WHILE
          MAKING THE PROCESS TRANSPARENT AND EASIER FOR YOU TARGETS.{" "}
        </h1>
      ),
    },
    {
      value: (
        <h1>
          <span className=" text-[#FF3452] text-3xl">
            SMART ACCESS PERMITTING ONLINE{" "}
          </span>{" "}
          <br /> APPLICATION THAT DOES IT ALL, AND COVERS ALL SCENERIO’S.{" "}
        </h1>
      ),
    },
    {
      value: (
        <h1>
          <span className=" text-[#FF3452] text-3xl">
            SINGLE SOURCE OF TRUTH AND AUTHORITY{" "}
          </span>{" "}
          <br />
          PASSAGE ALLOWS FOR PROACTIVE ACCESS MANAGEMENT, AND ALLOWS YOU TO SEE
          INTO FUTURE FOR IMPACT AND VALUE MANAGEMENT. <br /> <br /> TERRESTRIAL
          AND OCEAN{" "}
        </h1>
      ),
    },
    {
      value: (
        <h1>
          <span className=" text-[#FF3452] text-3xl">SMART AUTO SCREENING</span>{" "}
          <br />
          AND SUBMITTER IDENTIFICATION AUTHENTICATION. <br /> <br />
          <span className=" text-[#FF3452] text-3xl">
            STREAMLINE TRUST{" "}
          </span>{" "}
          <br />
          AND TRANSPARENCY FOR ALL PARTIES
        </h1>
      ),
    },
    {
      value: (
        <h1>
          <span className=" text-[#FF3452] text-3xl">
            SELF FUND YOUR EXISTING POLICIES
          </span>
          <br />
          PROTOCOLS, AND PROCEEDURES FROM COMMUNITIES AND UP.
          <span className=" text-[#FF3452] text-3xl">
            {" "}
            A SELF FUNDING MODEL
          </span>{" "}
          <br />A SELF-SUSTAINABLE MANAGEMENT.
        </h1>
      ),
    },
    {
      value: (
        <h1>
          {" "}
          <span className=" text-[#FF3452] text-3xl">
            EMPOWER YOUR CURRENT PROTOCOLS
          </span>{" "}
          <br />
          AND STREAMLINE IT WITH EASY TO FOLLOW AND ENFORCED WORKFLOW, CUSTOM TO
          EACH.
          <br /> <br />
          <span className=" text-[#FF3452] text-3xl">
            ELIMINATE HUMAN ERRORS
          </span>{" "}
          <br />
          REMOVE RISKS OF MANAGEMENT CHANGES, AND HAVE THE BENEFIT OF ON DEMAND
          PROFFESSONALS FOR ADDED APPLICATION OPINIONS. <br /> <br />
          <span className=" text-[#FF3452] text-3xl">
            ALL WHILE CREATING
          </span>{" "}
          <br />
          YOUR OWN KNOWLEDGEBASE. FOR TODAY, AND FUTURE
        </h1>
      ),
    },
  ];

  useEffect(() => {
    function LottieScrollTrigger(vars, animationTimeline) {
      let playhead = { frame: 0 },
        target = gsap.utils.toArray(vars.target)[0],
        animation = Lottie.loadAnimation({
          container: target,
          renderer: vars.renderer || "svg",
          loop: false,
          autoplay: false,
          path: vars.path,
        });
      animation.addEventListener("DOMLoaded", function () {
        animationTimeline
          .to(playhead, {
            ease: "none",
            duration: 20,
            frame: animation.totalFrames - 1,
            onUpdate: () => animation.goToAndStop(playhead.frame, true),
          })
          .to(
            ".descriptions",
            {
              right: "auto",
              left: 0,
            },
            "<-=2"
          )
          .to(
            ".descriptions-container",
            {
              autoAlpha: 1,
              x: "30px",
              duration: 3,
            },
            "<"
          )
          .to(".descriptions-container", {
            x: "40px",
            duration: 3,
          })
          .to(".descriptions-container", {
            x: "40px",
            duration: 3,
          })
          .to(".descriptions-container", {
            autoAlpha: 0,
            x: "30px",
            duration: 3,
          })
          .to(
            ".oip-workflow .card-transparent",
            {
              translateZ: "0px",
              duration: 1,
            },
            "<"
          )
          .to(
            ".oip-workflow .card-border",
            {
              translateZ: "0px",
              duration: 1,
            },
            "<"
          )
          .to(
            ".oip-workflow .card-background",
            {
              autoAlpha: 0,
            },
            "<"
          )
          .to(".oip-container", {
            x: "0px",
            duration: 3,
          })
          .to(
            ".oip-container .perspective",
            {
              rotateY: "0deg",
              rotateZ: "0deg",
              duration: 3,
            },
            "<"
          )
          .to(".oip-container", {
            scale: 0,
            y: "500px",
            autoAlpha: 0,
            duration: 5,
          });
      });
      return animation;
    }

    const OipAnimation = gsap.timeline({
      scrollTrigger: {
        trigger: ".oip",
        start: "top",
        end: "+=10000",
        scrub: 1,
      },
    });
    OipAnimation.fromTo(
      ".oip-container",
      {
        autoAlpha: 0,
        scale: 0,
        duration: 1,
        onComplete: function () {
          setCount(0);
        },
      },
      { scale: 0.5, autoAlpha: 1, duration: 5 }
    )
      .from(".oip-container .perspective", {
        rotateX: "0deg",
        rotateY: "0deg",
        rotateZ: "0deg",
        duration: 0.5,
      })
      .from(".oip-container .transparent-card", {
        translateZ: "0px",
        duration: 1,
      })
      .from(
        ".oip-container .border-card",
        {
          translateZ: "0px",
          duration: 1,
        },
        "<"
      )
      .from(".oip-welcome .card-transparent", {
        translateZ: "0px",
        duration: 1,
      })
      .from(".oip-welcome .card-border", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-container", {
        x: "250px",
        duration: 3,
      })
      .to(
        ".oip-container .perspective",
        {
          rotateY: "-45deg",
          duration: 3,
        },
        "-=2"
      )
      .from(
        ".descriptions-container",
        {
          autoAlpha: 0,
          x: "200px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".descriptions-container", {
        x: "-25px",
        duration: 8,
      })
      .to(".descriptions-container", {
        x: "-25px",
        duration: 8,
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 0,
          x: "200px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".oip-welcome .card-transparent", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-welcome .card-border", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-welcome .card-background", {
        autoAlpha: 0,
      })
      .to(".oip-container .perspective", {
        rotateY: "45deg",
        duration: 3,
      })
      .to(
        ".oip-container",
        {
          x: "-250px",
          duration: 6,
        },
        "<"
      )
      .from(".oip-choices .card-background", {
        autoAlpha: 0,
        duration: 1,
      })
      .from(".oip-choices .card-transparent", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(0);
        },
      })
      .from(".oip-choices .card-border", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(1);
        },
      })
      .to(".descriptions", {
        right: 0,
        left: "auto",
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 1,
          x: "30px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".descriptions-container", {
        x: "40px",
        duration: 8,
        onComplete: function () {
          setCount(1);
        },
      })
      .to(".descriptions-container", {
        x: "40px",
        duration: 8,
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 0,
          x: "30px",
          duration: 3,
          onComplete: function () {
            setCount(2);
          },
        },
        "<+=2"
      )
      .to(".oip-container .perspective", {
        rotateY: "35deg",
        duration: 3,
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 1,
          x: "30px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".descriptions-container", {
        x: "40px",
        duration: 8,
      })
      .to(".descriptions-container", {
        x: "40px",
        duration: 8,
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 0,
          x: "30px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".oip-container", {
        x: "250px",
        duration: 3,
      })
      .to(
        ".oip-container .perspective",
        {
          rotateY: "-35deg",
          duration: 3,
        },
        "<"
      )
      .to(".oip-choices .card-transparent", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-choices .card-border", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-choices .card-background", {
        autoAlpha: 0,
      })
      .to(".descriptions", {
        right: "auto",
        left: 0,
      })
      .from(".oip-email .card-background", {
        autoAlpha: 0,
        duration: 1,
      })
      .from(".oip-email .card-transparent", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(2);
        },
      })
      .from(".oip-email .card-border", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(3);
        },
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 1,
          duration: 3,
        },
        "<+=2"
      )
      .to(".descriptions-container", {
        x: "-25px",
        duration: 8,
      })
      .to(".oip-email .card-transparent", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-email .card-border", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-email .card-background", {
        autoAlpha: 0,
      })
      .to(".descriptions-container", {
        x: "-25px",
        duration: 8,
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 0,
          x: "200px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".oip-container .perspective", {
        rotateY: "35deg",
        duration: 3,
      })
      .to(
        ".oip-container",
        {
          x: "-250px",
          duration: 6,
        },
        "<"
      )
      .from(".oip-pay .card-background", {
        autoAlpha: 0,
        duration: 1,
      })
      .from(".oip-pay .card-transparent", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(3);
        },
      })
      .from(".oip-pay .card-border", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(4);
        },
      })
      .to(".descriptions", {
        right: 0,
        left: "auto",
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 1,
          x: "30px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".descriptions-container", {
        x: "40px",
        duration: 8,
      })
      .to(".descriptions-container", {
        x: "40px",
        duration: 8,
      })
      .to(
        ".descriptions-container",
        {
          autoAlpha: 0,
          x: "30px",
          duration: 3,
        },
        "<+=2"
      )
      .to(".oip-pay .card-transparent", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-pay .card-border", {
        translateZ: "0px",
        duration: 1,
      })
      .to(".oip-pay .card-background", {
        autoAlpha: 0,
      })
      .to(".oip-container", {
        x: "200px",
        duration: 3,
      })
      .to(
        ".oip-container .perspective",
        {
          rotateY: "-35deg",
          rotateZ: "10deg",
          duration: 3,
        },
        "<"
      )
      .from(".oip-workflow .card-background", {
        autoAlpha: 0,
        duration: 1,
      })
      .from(".oip-workflow .card-transparent", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(4);
        },
      })
      .from(".oip-workflow .card-border", {
        translateZ: "0px",
        duration: 1,
        onComplete: function () {
          setCount(5);
        },
      });
    LottieScrollTrigger(
      {
        target: "#animationWindow",
        path: "https://res.cloudinary.com/dl5mqatis/raw/upload/v1648013561/passage/passage-showcase/lottie/workflow_u1ps5b.json",
        speed: "medium",
      },
      OipAnimation
    );
  }, []);
  return (
    <>
      <div className="descriptions absolute top-0 left-0 z-20 flex justify-center items-center w-1/2 h-full">
        <div className="descriptions-container w-1/2 h-auto">
          {descriptions[count].value}
        </div>
      </div>
      <div className="oip-container flex justify-center w-full h-full align-middle scale-50">
        <Container innerContent={<OipUi />}></Container>
      </div>
    </>
  );
}

export default OipContainer;
